export default class Application {
  constructor() {
    this.applicationId = "";
    this.sharedSecret = "";
  }
}
